import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export default function PercentLiner({
  children,
  className,
  isMobile,
  percentClassName,
  percentage,
  showPercent,
}) {
  return (
    <div className={cx('liner', className, isMobile && 'mobile')}>
      <div className={cx('content', isMobile && 'mobile')}>{children}</div>
      <div className={cx('lineWrap', isMobile && 'mobile')}>
        <span className={cx('line', isMobile && 'mobile')} style={{ width: `${percentage}%` }} />
        {showPercent && (
          <span
            className={cx(percentClassName, 'percent', isMobile && 'mobile')}
          >{`${percentage}%`}</span>
        )}
      </div>
    </div>
  );
}

PercentLiner.propTypes = {
  children: PropTypes.any,
  className: PropTypes.any,
  isMobile: PropTypes.bool,
  percentClassName: PropTypes.string,
  percentage: PropTypes.number,
  showPercent: PropTypes.bool,
};
